import { CvpLocale } from "../../WSUtils/getIdLanguage";
import { CvpSettings } from "./CvpSettings";

export const DEFAULT_SETTINGS: CvpSettings = {
  idConcern: window.cvpIdConcern?.toString(),
  idEmbed: null,

  // UPDATE CODE HERE WHEN ADDING NEW SETTING (4)
  iframe: true,
  theme: "bootstrap4-light-purple",
  cssUrl: null,
  css: null,
  fontSize: "16px",
  startPage: "jobs",
  backgroundColor: "var(--surface-50)",
  fontFamily: "var(--font-family)",
  primaryColor: "var(--primary-color)",
  locale: CvpLocale.nb,
  jobview_showContactImage: false,
  iframe_joblist_showLoginButton: true,
  logoPrimary: null,
  logoJobFallback: null,
  departments: null,
};
